import { combineReducers } from "@reduxjs/toolkit"

import {
    callReducer,
    chatReducer,
    clientCallNotificationReducer,
    userReducer,
    psyCatalogMetaReducer,
    surveyReducer,
    psyCatalogReducer,
} from "./slices"

import { bookingFlowReducer } from "@modules/BookingFlow/store/slice"

export const rootReducer = combineReducers({
    call: callReducer,
    chat: chatReducer,
    clientCallNotification: clientCallNotificationReducer,
    bookingFlow: bookingFlowReducer,
    user: userReducer,
    psyCatalogMeta: psyCatalogMetaReducer,
    survey: surveyReducer,
    psyCatalog: psyCatalogReducer,
})
